import Vue from 'vue';
import { indexOf } from 'lodash';
import api from 'src/api';
import { l } from 'src/utils/helper';

import {
  getActivityById,
  CREATE_BLANK_ACTIVITY,
  SET_ACTIVITY_LOADED,
  fetchActivity,
} from 'src/store/modules/activities';
import { isExternalOperator } from 'src/store/modules/user';

// в константы выносим тольконазвания мутаций/экшенов,
// которые переиспользуем/планируем переиспользовать
export const resumeActivity = 'resumeActivity';
export const UPDATE_META_DATA_FOR_ACTIVITY = 'UPDATE_META_DATA_FOR_ACTIVITY';
export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const REMOVE_ACTIVITY = 'REMOVE_ACTIVITY';
export const PUT_ACTIVITY_AT_THE_END_OF_ACTIVITIES_LIST = 'PUT_ACTIVITY_AT_THE_END_OF_ACTIVITIES_LIST';

const data = {
  fetching: false,
  fetchAt: new Date(0),
  selectedActivityId: null,
  activities: [],
  meta: {}, // TODO описать макс. полную структуру мета
};

function createMeta(atr) {
  return {
    online: false,
    typing: false,
    inputText: '',
    autoClose: false,
    isClosed: false,
    onHold: false,
    onlineAt: undefined,
    isLeft: false,
    previous_activity: {
      state: '',
      closedBy: '',
    },
    ...atr,
  };
}

const actions = {
  fetchActivities({ commit, rootGetters }) {
    commit('SET_FETCHING');
    const isExternalOperatorVal = rootGetters[`user/${isExternalOperator}`];
    return api.getCurrentActivities(isExternalOperatorVal).then((activities) => {
      const meta = {};
      const list = activities.map((activity) => {
        const activityId = activity.id;
        const getActivity = rootGetters[`activities/${getActivityById}`];
        if (typeof getActivity(activityId) === 'undefined') {
          commit(`activities/${CREATE_BLANK_ACTIVITY}`, { id: activityId }, { root: true });
        }
        const stateActivity = getActivity(activityId);

        commit(`activities/${SET_ACTIVITY_LOADED}`, {
          activity: stateActivity,
          response: activity,
        }, { root: true });
        meta[activity.id] = createMeta({
          isClosed: activity.state === 'closed',
          onHold: activity.state === 'on_hold',
        });
        return activityId;
      });
      commit('SET_ACTIVITIES_LOADED', { list, meta });
    }).catch((err) => {
      commit('SET_STOP_FETCHING');
      l.error(err);
      throw err;
    });
  },
  putActivityOnHold({ commit, rootGetters }, activityId) {
    const getActivity = rootGetters[`activities/${getActivityById}`];
    const stateActivity = getActivity(activityId);
    return api.holdActivity(activityId).then((res) => {
      commit(`activities/${SET_ACTIVITY_LOADED}`, {
        activity: stateActivity,
        response: res,
      }, { root: true });
      commit(PUT_ACTIVITY_AT_THE_END_OF_ACTIVITIES_LIST, activityId);
      // убираем отображение таймера preHold (если был)
      commit(UPDATE_META_DATA_FOR_ACTIVITY, {
        activityId,
        meta: { preHold: false },
      });
    }).catch((error) => {
      l.error(error);
      throw error;
    });
  },
  resumeActivity({ dispatch, commit, rootGetters }, activityId) {
    const getActivity = rootGetters[`activities/${getActivityById}`];
    const oldStateActivity = getActivity(activityId).state;
    if (oldStateActivity === 'on_hold') {
      dispatch(`activities/${fetchActivity}`, { id: activityId, force: true }, { root: true }).then(() => {
        if (getActivity(activityId).state === 'in_progress') {
          const messagesFromOperator = getActivity(activityId).messages
            .filter((msg) => msg.activityId === activityId && msg.sender === 'operator' && !msg.auto);
          const isNewActivity = messagesFromOperator.length === 0;
          commit('PUT_ACTIVITY_AT_THE_BEGINNING_OF_ACTIVITIES_LIST', activityId);
          commit(UPDATE_META_DATA_FOR_ACTIVITY, {
            activityId,
            meta: { isNew: isNewActivity },
          });
        }
      });
    }
  },
};

const mutations = {
  ADD_ACTIVITY(state, activityId) {
    const { activities, selectedActivityId, meta } = state;
    if (activities.length === 1 && meta[selectedActivityId] && meta[selectedActivityId].onHold) {
      state.activities.unshift(activityId);
      state.selectedActivityId = activityId;
    } else state.activities.unshift(activityId);
    Vue.set(state.meta, activityId, createMeta());
  },
  REMOVE_ACTIVITY(state, activityId) {
    if (indexOf(state.activities, activityId) !== -1) {
      state.activities.splice(indexOf(state.activities, activityId), 1);
      if (state.selectedActivityId === activityId) state.selectedActivityId = null;
      Vue.delete(state.meta, activityId);
    }
  },
  SELECT_ACTIVITY(state, activityId) {
    if (indexOf(state.activities, activityId) !== -1) {
      state.selectedActivityId = activityId;
    } else {
      state.selectedActivityId = null;
    }
  },
  PUT_ACTIVITY_AT_THE_BEGINNING_OF_ACTIVITIES_LIST(state, activityId) {
    const index = indexOf(state.activities, activityId);
    const { activities } = state;
    if (index !== -1) {
      mutations.UPDATE_META_DATA_FOR_ACTIVITY(state, {
        activityId,
        meta: { onHold: false },
      });
      if (activities.length !== 1) {
        state.activities.unshift(activities[index]);
        state.activities.splice(index + 1, 1);
      }
    }
  },
  PUT_ACTIVITY_AT_THE_END_OF_ACTIVITIES_LIST(state, activityId) {
    const index = indexOf(state.activities, activityId);
    const { activities } = state;
    if (index !== -1) {
      mutations.UPDATE_META_DATA_FOR_ACTIVITY(state, {
        activityId,
        meta: { onHold: true },
      });
      if (activities.length !== 1) {
        state.activities.push(activities[index]);
        state.activities.splice(index, 1);
      }
    }
  },
  SET_FETCHING(state) {
    state.fetching = true;
    state.fetchAt = new Date();
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  SET_ACTIVITIES_LOADED(state, { list, meta }) {
    state.fetching = false;
    state.fetchAt = new Date(0);
    state.activities = list;
    state.meta = meta;
  },
  UPDATE_META_DATA_FOR_ACTIVITY(state, { activityId, meta }) {
    if (state.meta[activityId]) {
      Object.keys(meta).forEach((key) => Vue.set(state.meta[activityId], key, meta[key]));
    }
  },
};

const getters = {
  activitiesList(state, $getters, rootState, rootGetters) {
    return state.activities
      .map((activityId) => rootGetters[`activities/${getActivityById}`](activityId))
      .filter((activity) => activity);
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
  getters,
};

export default store;

export class GET {
}
